// @flow

import * as React from 'react';

import clsx from 'clsx';

import { Svg } from '@gandi/ui';

import styles from './Intro.scss';

export type Props = {
  title: React.Node,
  icon?: string,
  prefix?: React.Node,
  sticky?: boolean,
  centered?: boolean,
  children?: React.Node,
  className?: string,
};

function Intro({
  icon,
  prefix,
  title,
  sticky,
  centered = true,
  children,
  className,
}: Props): React.MixedElement {
  const hasIcon = !!icon && Svg.has(icon);

  const rootClasses = clsx(
    styles.root,
    {
      [styles.sticky]: sticky,
    },
    className,
  );

  const headerClasses = clsx(styles.head, {
    [styles.justifyContentCenter]: centered,
  });

  const titleClasses = clsx(styles.title, {
    [styles.centered]: !hasIcon && !prefix,
  });

  return (
    <div className={rootClasses}>
      <header className={headerClasses}>
        {prefix}
        {icon && hasIcon && <Svg name={icon} className={styles.icon} />}
        <h1 className={titleClasses}>{title}</h1>
      </header>
      {children}
    </div>
  );
}

export { Intro };
